import React from 'react';

export default function Layout({ children }) {
  return (
    <div className="min-h-screen bg-gradient-to-br from-brand-beige to-[#FDE8D0] flex flex-col font-body selection:bg-brand-blue selection:text-white">
      <header className="py-4 px-4 md:px-8 border-b border-brand-blue/5 bg-white/70 backdrop-blur-md sticky top-0 z-50 shadow-sm">
        <div className="max-w-4xl mx-auto flex items-center justify-center">
          <img 
            src="https://www.crossandpen.com/wp-content/uploads/2026/05/cp_logo-final.png" 
            alt="CROSS + PEN" 
            className="h-10 md:h-12 w-auto object-contain"
          />
        </div>
      </header>
      
      <main className="flex-1 w-full max-w-3xl mx-auto px-4 py-12 md:py-20 flex flex-col justify-center">
        {children}
      </main>
      
      <footer className="py-8 px-4 text-center text-gray-400 text-sm font-body">
        <p>© {new Date().getFullYear()} CROSS + PEN. All rights reserved.</p>
      </footer>
    </div>
  );
}